import Formsy from 'formsy-react'

import { deliveryAddressSelector } from 'auth/selectors'
import {
    CREDENTIAL_DIGITAL,
    DIGITAL_PASS_ACCESS_ID,
    DIGITAL_PASS_NAME,
    DIGITAL_PASS_PRICE,
} from 'purchase-flow/constants'

import DigitalAccessOption from './DigitalAccessOption'
import AddressSectionForm from '../AddressSectionForm'
import PhysicalAccessOption from './PhysicalAccessOption'

const AccessOptionsContent = ({
    accessOptionProducts,
    isRateSelected,
    accessCardsDesc,
    showDigitalOption,
    setSelectedDeliveryRate,
    setIsActiveAccessCard,
    isRateDigitalOption,
    showPhysicalOption,
    showForm,
    selectedDeliveryRate,
    selectDeliveryRate,
    isActiveAccessCard,
    onNextClick,
    translate: t,
    deliveryAddress,
    deliveryHomeSelected,
    setEnableNextBtn,
    shouldRenderProductsWithRates,
}) => (
    <div>
        {accessCardsDesc}
        {showDigitalOption && (
            <DigitalAccessOption
                selectDeliveryRate={() => {
                    setSelectedDeliveryRate({
                        accessId: DIGITAL_PASS_ACCESS_ID,
                        typeCode: CREDENTIAL_DIGITAL.toUpperCase(),
                        prdctName: t('Subscription.purchase.accessoptions.digitalpass.option.label'),
                        rate: {
                            name: DIGITAL_PASS_NAME,
                            price: DIGITAL_PASS_PRICE,
                        },
                    })
                    setIsActiveAccessCard(false)
                }}
                isSelected={isRateDigitalOption}
            />
        )}
        {showPhysicalOption && (
            <PhysicalAccessOption
                showForm={showForm}
                accessOptionProducts={accessOptionProducts}
                selectDeliveryRate={selectDeliveryRate}
                selectedDeliveryRate={selectedDeliveryRate}
                isRateSelected={isRateSelected}
                selectRate={selectDeliveryRate}
                isActiveSelected={selectedDeliveryRate?.ratePlanId && isRateSelected(selectedDeliveryRate)}
                isActiveAccessCard={isActiveAccessCard}
                setIsActiveAccessCard={setIsActiveAccessCard}
                deliveryAddress={deliveryAddress}
                shouldRenderProductsWithRates={shouldRenderProductsWithRates}
            />
        )}
        <Formsy
            onSubmit={onNextClick}
            onValid={() => {
                deliveryHomeSelected && setEnableNextBtn(true)
            }}>
            {(deliveryHomeSelected || showForm) && (
                <AddressSectionForm
                    address={deliveryAddress}
                    forceShowForm={showForm}
                    type="delivery"
                    formCaption={
                        <h3 className="mt-5 mb-3 text-uppercase font-weight-bold">
                            <T>subscription.purchase.label.delivery</T>
                        </h3>
                    }
                />
            )}
        </Formsy>
    </div>
)

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            deliveryAddress: deliveryAddressSelector,
        })
    )
)(AccessOptionsContent)
